<div class="container">
  <form (submit)="$event.preventDefault(); searchSubmit()">
    <input type="search" id="search-input" name="query" placeholder="{{stringsService.strings['SEARCH']}}" [(ngModel)]="query" />
  </form>
  @if (!people || people.length === 0) {
    <div id="empty-result">
      <p>{{stringsService.strings['NO_RESULTS_FOUND']}}</p>
    </div>
  }
  @if (people && people.length > 0) {
    <table id="searchtable" class="maintable">
      <tr>
        <th>{{stringsService.strings['NAME']}}</th>
        <th>{{stringsService.strings['EMPNUMBER']}}</th>
        <th>{{stringsService.strings['WORK_EMAIL']}}</th>
        <th>{{stringsService.strings['WORK_CELLPHONE']}}</th>
      </tr>
      @for (person of people; track person) {
        <tbody (click)="router.navigate(['/employee/' + person.id])">
          <tr>
            <td>{{person.first_name}} {{person.last_name}}</td>
            <td>{{person.employee_number}}</td>
            <td>@if (person.work_email) {
              <span>{{person.work_email}}</span>
            }</td>
            <td>@if (person.work_cellphone) {
              <span>{{person.work_cellphone}}</span>
            }</td>
          </tr>
        </tbody>
      }
    </table>
  }
</div>
